import { SagaIterator } from "redux-saga";
import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { RequestAction } from "store/entities/actions";
import { IApplicationWidget, IWidget } from "store/entities/applications";
import { ApplicationsActionNames } from "store/entities/applications/actions";
import { ApplicationWidgetPlacement } from "store/entities/applications/interfaces";
import { getWidgetsWithPlacement } from "store/entities/applications/selectors";
import { ApplicationsActions } from "store/features/applications/actions";
import { getLoadedFullscreenWidgets } from "store/features/applications/selectors";
import { IActionWithPayload } from "store/helper";

import { FullscreenWidgetsViewActionNames, FullscreenWidgetsViewActions } from "./actions";
import { ILoadWidgetPayload } from "./interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function updateDocumentTitle(widget: IWidget) {
  // @ts-expect-error TS(2322)
  document.title = widget.name;
}

function* loadWidget(
  action: IActionWithPayload<FullscreenWidgetsViewActionNames.LOAD_WIDGET, ILoadWidgetPayload>
): SagaIterator {
  const { id: targetWidgetId, loadedOnAgentAppInit } = action.payload;

  const widgets: IWidget[] = yield select(getWidgetsWithPlacement, ApplicationWidgetPlacement.FullScreen);
  const targetWidget = widgets.find(app => app.id === targetWidgetId);

  if (!targetWidget) {
    return;
  }

  const loadedWidgetIds: string[] = yield select(getLoadedFullscreenWidgets);
  const isTargetWidgetLoaded = !!loadedWidgetIds.find(id => targetWidgetId === id);

  if (!loadedOnAgentAppInit) {
    yield call(updateDocumentTitle, targetWidget);
  }

  if (!isTargetWidgetLoaded) {
    yield put(ApplicationsActions.loadFullscreenWidget(targetWidgetId));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* widgetsFetched() {
  const widgets: IApplicationWidget[] = yield select(getWidgetsWithPlacement, "fullscreen");

  yield all(
    widgets.map(widget =>
      put(
        FullscreenWidgetsViewActions.load({
          id: widget.id,
          loadedOnAgentAppInit: true,
        })
      )
    )
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fullscreenWidgetsViewSagas() {
  yield all([
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    yield takeLatest(FullscreenWidgetsViewActionNames.LOAD_WIDGET, loadWidget),
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    yield takeLatest(ApplicationsActionNames.INSTALLED_APPS[RequestAction.SUCCESS], widgetsFetched),
  ]);
}
